import { combineReducers } from 'redux';

import WebhookTypes from './types';

export const webhookReducer = combineReducers({
  listUrls: WebhookTypes.listUrls.getReducer(),
  listHistory: WebhookTypes.listHistory.getReducer(),
  listSends: WebhookTypes.listSends.getReducer(),
  listProducts: WebhookTypes.listProducts.getReducer(),
  updateUrl: WebhookTypes.updateUrl.getReducer(),
  createUrl: WebhookTypes.createUrl.getReducer(),
  sendTest: WebhookTypes.sendTest.getReducer(),
  resendWebhook: WebhookTypes.resendWebhook.getReducer(),
});
